function filterData(_ref) {
  var data = _ref.data,
      searchable = _ref.searchable,
      limit = _ref.limit,
      searchValue = _ref.searchValue,
      filter = _ref.filter,
      value = _ref.value,
      filterDataOnExactSearchMatch = _ref.filterDataOnExactSearchMatch;

  if (!searchable) {
    return data;
  }

  var selected = value != null ? data.find(function (item) {
    return item.value === value;
  }) || null : null;

  if (selected && !filterDataOnExactSearchMatch && (selected == null ? void 0 : selected.label) === searchValue) {
    if (limit) {
      if (limit >= data.length) {
        return data;
      }

      var firstIndex = data.indexOf(selected);
      var lastIndex = firstIndex + limit;
      var firstIndexOffset = lastIndex - data.length;

      if (firstIndexOffset > 0) {
        return data.slice(firstIndex - firstIndexOffset);
      }

      return data.slice(firstIndex, lastIndex);
    }

    return data;
  }

  var result = [];

  for (var i = 0; i < data.length; i += 1) {
    if (filter(searchValue, data[i])) {
      result.push(data[i]);
    }

    if (result.length >= limit) {
      break;
    }
  }

  return result;
}

export { filterData };